import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'flexara_cookie_consent';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = (all: boolean) => {
    localStorage.setItem(STORAGE_KEY, all ? 'all' : 'necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10000,
      background: '#1a1a30', borderTop: '1px solid #2a2a4a',
      padding: '1rem 1.5rem', fontFamily: 'DM Sans, sans-serif',
    }}>
      <div style={{
        maxWidth: '900px', margin: '0 auto',
        display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap',
      }}>
        <p style={{ color: '#c0c0e0', fontSize: '0.85rem', margin: 0, flex: 1, minWidth: '260px' }}>
          Folosim cookies strict necesare pentru funcționarea aplicației. Nu folosim cookies de tracking sau publicitate.{' '}
          <span onClick={() => navigate('/cookies')}
            style={{ color: '#4a4ad8', cursor: 'pointer', textDecoration: 'underline' }}>
            Politica Cookies
          </span>
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexShrink: 0 }}>
          <button onClick={() => accept(false)} style={{
            padding: '0.5rem 1rem', borderRadius: '8px',
            border: '1px solid #2a2a4a', background: 'transparent',
            color: '#8080a0', cursor: 'pointer', fontSize: '0.85rem',
          }}>
            Doar necesare
          </button>
          <button onClick={() => accept(true)} style={{
            padding: '0.5rem 1.2rem', borderRadius: '8px', border: 'none',
            background: '#4a4ad8', color: '#fff', cursor: 'pointer',
            fontSize: '0.85rem', fontWeight: 600,
          }}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
